export const ICON_BUTTONS = {
  primary: {
    blue: 'primary blue',
    green: 'primary green',
    red: 'primary red',
    black: 'primary black',
  },
  outlined: {
    blue: 'outlined blue',
    black: 'outlined black',
    gray: 'outlined gray',
  },
  ghost: {
    blue: 'ghost blue',
    black: 'ghost black',
    gray: 'ghost gray',
  },
  transparent: {
    blue: 'transparent blue',
    black: 'transparent black',
    gray: 'transparent gray',
  },
} as const;
